export default {

  namespaced: true,

  state: () => ({

    billsPayable: {},

    billPayable: {},

    sumBillsPayableOverDueMonth: {},

    sumBillsPayedMonth: {},

    sumOverDueBillPayable: {},

    sumOverDueToday: {},

    sumCanceled: {},
  }),

  getters: {
    getSumBillsPayableOverDueMonth(state) {
      try {
        return state.sumBillsPayableOverDueMonth
      } catch (error) {
        return 0
      }
    },

    getsumBillsPayedMonth(state) {
      try {
        return state.sumBillsPayedMonth
      } catch (error) {
        return 0
      }
    },

    getsumOverDueBillPayable(state) {
      try {
        return state.sumOverDueBillPayable
      } catch (error) {
        return 0
      }
    },

    getsumOverDueToday(state) {
      try {
        return state.sumOverDueToday
      } catch (error) {
        return 0
      }
    },

    getsumCanceled(state) {
      try {
        return state.sumCanceled
      } catch (error) {
        return 0
      }
    },
  },

  mutations: {

    setStatsCardData(state, data) {
      state.sumBillsPayableOverDueMonth = data.sumBillsPayableOverDueMonth.value_sum;
      state.sumBillsPayedMonth = data.sumBillsPayedMonth.value_sum;
      state.sumOverDueBillPayable = data.sumOverDueBillPayable.value_sum;
      state.sumOverDueToday = data.sumOverDueToday.value_sum;
      state.sumCanceled = data.sumCanceled.value_sum;
    },

    setBillsPayable(state, { data }) {
      state.billsPayable = data
    },

    setBillPayable(state, { data }) {
      state.billPayable = data
    },
  },

  actions: {

    async getStatsBillsPayable({ $axios, commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get("/erp/billpayable/stats-billpayable", { params: params }).then((response) => {
          commit('setStatsCardData', response.data);
          resolve(response.data)
        }).catch(error => {
          reject(error)
        });
      });
    },

    async getBillsPayable({ $axios, commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get("/erp/billpayable/billpayable", { params: params })
          .then((response) => {
            commit('setBillsPayable', response)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          });
      });
    },

    async getBillPayable({ $axios, commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get("/erp/billpayable/billpayable/" + id).then((response) => {
          commit('setBillPayable', response)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        });
      })
    },

    async putBillPayable({ $axios, commit }, { form, id }) {
      let url = "/erp/billpayable/billpayable"
      if (id) {
        url = url + '/' + id
      }
      return new Promise((resolve, reject) => {
        axios.put(url, form)
          .then((response) => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          });
      });
    },

    async deleteBillPayable({ $axios, commit }, params) {
      return new Promise((resolve, reject) => {
        axios.delete("/erp/billpayable/billpayable/" + params)
          .then((response) => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          });
      });
    },

    async postInsertBillPayable({ $axios, commit }, params) {
      return new Promise((resolve, reject) => {
        axios.post("/erp/billpayable/billpayable", params).then((response) => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        });
      });
    },

    async postPayBillPayable({ $axios, commit }, params) {
      return new Promise((resolve, reject) => {
        axios.post("/erp/billpayable/pay-billpayable", params)
          .then((response) => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          });
      });
    },

    async getBillPayableReport({ $axios, commit }, params) {
      const data = await axios.get("/erp/billpayable/report-billpayable", { params: params });
      return data;
    },
  }
}
